<template>
  <div class="study">
    <div class="study-container">
      <div class="top-banner">
        <van-search
          v-model="kw"
          shape="round" background="#4074ea" 
          placeholder="请输入搜索关键词"
          @search="searchKW"
        />
        <van-tabs
          title-active-color="#ffffff" 
          title-inactive-color="#f0f0f0"
          v-model="activeTab"
          @change="tabChange"
        >
          <van-tab title="新增" :name="0"></van-tab>
          <van-tab title="待入群" :name="1"></van-tab>
          <van-tab title="已入群" :name="2"></van-tab>
          <van-tab title="已退群" :name="3"></van-tab>
          <van-tab title="黑名单" :name="9"></van-tab>
        </van-tabs>
      </div>
      <div class="content">
        <div class="member-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="loadBusy" infinite-scroll-distance="30">
          <van-pull-refresh v-model="loadBusy" @refresh="onRefresh" style="min-height: 100%">
          <template v-if="list.length > 0">
            <div class="member-item" v-for="mem in list" :key="mem.id">
              <div class="item-header">
                ID: {{ mem.id }} · {{ mem.member_type == 101 ? '未注册' : mem.mobile }} · <van-tag :type="statusTypeMap[mem.user_status] ?? 'default'">{{ statusMap[mem.user_status] }}</van-tag>
              </div>
              <div class="stat">
                <div>{{ mem.member_type == 101 ? '首次完播' : '注册' }}时间：{{ mem.actived_at }}</div>
                <div>视频播放次数：{{ mem.total_play_count }} 视频完播次数：{{ mem.total_play_finish }}</div>
                <div>答题次数：{{ mem.total_answer_question }} 正确答题次数：{{ mem.correct_answer_question }} </div>
                <div>红包领取次数：{{ mem.total_rp_count }}</div>
              </div>
              <div class="action">
                <div class="btn" @click="handleInfo(mem)">信息</div>
                <div 
                  v-if="[0, 1, 2].includes(mem.user_status)"
                  :class="'btn' + (mem.newbee_rp > 0 ? ' rpget': ' rpnone')"
                  @click="sendRp(mem)"
                >新人红包</div>
                <van-popover v-model="mem.modify" trigger="click" :actions="getActions(mem)" @select="onSelect">
                  <template #reference>
                    <div class="btn">变更状态</div>
                  </template>
                </van-popover>
              </div>
              <div class="item-avatar">
                <div class="icon" :style="{
                  backgroundImage: 'url('+mem.headimgurl+')'
                }"></div>
                <div class="nick">{{mem.nickname}}</div>
              </div>
            </div>
          </template>
          <template v-else>
            <van-empty description="暂无更多内容" />
          </template>
          </van-pull-refresh>
        </div>
      </div>
    </div>
    <van-dialog v-model="showEdit" title="信息">
      <van-field name="headimgurl" label="头像" input-align="right" :center="true">
        <template #input>
          <img :src="editForm.headimgurl"  class="headicon" />
        </template>
      </van-field>
      <van-field label="昵称" input-align="right" :value="editForm.nickname" readonly />
      <van-field label="手机号" input-align="right" :value="editForm.mobile" readonly />
      
    </van-dialog>
    <Footer />
    <GMError />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import GMError from './component/GMError.vue';
import { mapState } from 'vuex'
import { Toast, Dialog } from 'vant'
import { customerList, customerUpdate, customerRedpack } from '@/api/group_master'

export default {
  name: 'GMCustomer',
  components: {
    Footer, GMError
  },
  data() {
    return {
      loadBusy: false,
      page: 1,
      activeTab: 0,
      total_page: 0,
      list: [],
      kw: '',
      meta: {
        status: -1,
        keyword: '',
        page: 1,
      },
      showEdit: false,
      editId: undefined,
      editForm: {
        headimgurl: '',
        nickname: '',
        mobile: '',
      },
    }
  },
  computed: {
    ...mapState(['user']),
    res_url() {
      return window.__config__.res_url;
    },
    statusTypeMap() {
      return {
        0: 'default',
        1: 'warning',
        2: 'success',
        3: 'warning',
        9: 'danger'
      }
    },
    statusMap() {
      return {
        0: '新增',
        1: '待入群',
        2: '已入群',
        3: '已退群',
        9: '黑名单'
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.loadData()
    },
    searchKW() {
      console.log('search', this.kw)
      this.loadData({
        page: 1,
        status: this.activeTab,
        keyword: this.kw
      })
    },
    tabChange(evt) {
      console.log('tabChange', evt)
      this.loadData({
        page: 1,
        status: evt,
        keyword: this.kw
      })
    },
    onRefresh() {
      this.loadData({
        page: 1,
        status: this.meta.status,
        keyword: this.meta.keyword
      })
    },
    loadData({ page = 1, status = 0, keyword = '' } = {}) {
      this.loadBusy = true;
      customerList({
        page,
        status,
        keyword
      }).then((resp) => {
        let { current_page, data, last_page } = resp
        this.page = current_page
        this.total_page = last_page
        
        this.list = current_page == 1 ? data : this.list.concat(data)
        // console.log('list', this.list)
        this.loadBusy = false
        this.meta = {
          page,
          status,
          keyword
        }
      })
    },
    loadMore() {
      if (this.meta.page -1 < this.total_page) {
        this.loadData({
          page: this.meta.page + 1,
          status: this.meta.status,
          keyword: this.meta.keyword
        })
      }
    },
    getActions(mem) {
      return [{ text: '新增', status: 0 }, { text: '未入群', status: 1 }, { text: '已入群', status: 2 }, { text: '已退群', status: 3 }, { text: '黑名单', status: 9 }].map((v) => {
        return Object.assign(v, {
          mem
        })
      })
    },
    onSelect(evt) {
      customerUpdate(evt.mem.id, {
        status: evt.status
      }).then((resp) => {
        Toast.success('变更完成');
        this.onRefresh()
      })
    },
    onEdit(mem) {
      this.editId = mem.uuid
      this.editForm.real_name = mem.real_name
      this.editForm.mobile = mem.mobile
      this.showEdit = true
    },
    sendRp(mem) {
      if (mem.newbee > 0) {
        Toast('该用户已发过新人红包')
        return
      }
      Dialog.confirm({
        title: '确认',
        message: '您确认要给 ' + mem.nickname + ' 发放新人红包吗？'
      }).then(() => {
        // on confirm
        customerRedpack(mem.id).then((ret) => {
          Toast('已发放')
          this.$set(mem, 'newbee_rp', +(new Date()));
        })
      }).catch(() => {
        // on cancel
      });
    },
    handleInfo(mem) {
      this.editForm = mem
      this.showEdit = true
    }
  }
}
</script>
<style lang="scss" scoped>
.study-container {
  height: calc(100vh - 60px);
  width: 100%;
  display: flex;
  flex-direction: column;
  .top-banner {
    flex: 0 0 98px;
    background: #4074ea;
  }
  .content {
    flex: 1 1 auto;
    width: 100%;
    overflow: hidden;
    background: #e3e3e3;
    .member-list {
      height: 100%;
      width: 100%;
      // background: red;
      overflow-y: scroll;
      padding: 10px;
      .member-item {
        position: relative;
        padding: 10px;
        background: #fff;
        width: 100%;
        margin-bottom: 12px;
        min-height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .item-avatar {
          position: absolute;
          right: 0;
          top: 0;
          width: 90px;
          height: 110px;
          // background: #f2f2f2;
          padding: 10px 5px 10px 10px;
          .icon {
            width: 70px;
            height: 70px;
            background-size: contain;
            border-radius: 35px;
            overflow: hidden;
            box-shadow: 0px 0px 5px rgba(200, 200, 200, 0.9);
          }
          .nick {
            width: 70px;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: keep-all;
          }
        }
        .item-header {
          padding: 3px;
          color: #aaa;
          border-bottom: 1px solid #ccc;
        }

        .stat {
          & > div {
            font-size: 15px;
            margin: 3px 0;
            line-height: 1.5em;
          }
          margin: 5px 0;
        }
        .action {
          display: flex;
          .btn {
            width: 150px;
            line-height: 28px;
            font-size: 16px;
            border: 1px solid #ccc;
            text-align: center;
            border-left: none;
            &:first-child {
              border-left: 1px solid #ccc;
            }
            &.rpget {
              background: #ccc;
            }
            &.rpnone {
              background: #ad0000;
              color: #fff;
            }
          }
        }
        
      }
    }
  }
}
.video_container {
  width: 90vw;
  height: 52vw;
  video {
    width: 100%;
  }
}
.headicon {
  width: 50px;
  height: 50px;
  border-radius: 25px;
}
</style>
